import userReducer from '@app/store/slices/userSlice';
import authReducer from '@app/store/slices/authSlice';
import nightModeReducer from '@app/store/slices/nightModeSlice';
import themeReducer from '@app/store/slices/themeSlice';
import pwaReducer from '@app/store/slices/pwaSlice';
import permissonReducer from  '@app/store/slices/permissionSlice';
import reportMenusReducer from '@app/store/slices/reportSlice';
export default {
  user: userReducer,
  permission:permissonReducer,
  reportMenus: reportMenusReducer,
  auth: authReducer,
  nightMode: nightModeReducer,
  theme: themeReducer,
  pwa: pwaReducer,
};
